export enum ORDER_FULFILLMENT_OPTIONS {
  FULFILLED = 'FULFILLED',
  IN_PROGRESS = 'IN_PROGRESS',
  ON_HOLD = 'ON_HOLD',
  OPEN = 'OPEN',
  PARTIALLY_FULFILLED = 'PARTIALLY_FULFILLED',
  PENDING_FULFILLMENT = 'PENDING_FULFILLMENT',
  RESTOCKED = 'RESTOCKED',
  SCHEDULED = 'SCHEDULED',
  UNFULFILLED = 'UNFULFILLED'
}

export interface IOrderFulfillmentStatus {
  status: ORDER_FULFILLMENT_OPTIONS;
  label: string;
  color: string;
}

export const ORDER_FULFILLMENT_STATUS_OPTIONS = [
  {
    status: ORDER_FULFILLMENT_OPTIONS.FULFILLED,
    label: 'Fulfilled',
    color: 'primary'
  },
  {
    status: ORDER_FULFILLMENT_OPTIONS.IN_PROGRESS,
    label: 'In Progress',
    color: 'primary'
  },
  {
    status: ORDER_FULFILLMENT_OPTIONS.ON_HOLD,
    label: 'On Hold',
    color: 'warn'
  },
  {
    status: ORDER_FULFILLMENT_OPTIONS.OPEN,
    label: 'Open',
    color: 'secondary'
  },
  {
    status: ORDER_FULFILLMENT_OPTIONS.PARTIALLY_FULFILLED,
    label: 'Partially Fulfilled',
    color: 'primary'
  },
  {
    status: ORDER_FULFILLMENT_OPTIONS.PENDING_FULFILLMENT,
    label: 'Pending Fulfillment',
    color: 'secondary'
  },
  {
    status: ORDER_FULFILLMENT_OPTIONS.RESTOCKED,
    label: 'Restocked',
    color: 'primary'
  },
  {
    status: ORDER_FULFILLMENT_OPTIONS.SCHEDULED,
    label: 'Scheduled',
    color: 'primary'
  },
  {
    status: ORDER_FULFILLMENT_OPTIONS.UNFULFILLED,
    label: 'Unfulfilled',
    color: 'secondary'
  }
];
